module.exports = __webpack_public_path__ + "img/erase-sign.9d686639.svg";